export enum CipherRepromptType {
    None = 0,
    Password = 1,
}
